module.exports = __webpack_public_path__ + "static/media/convention-1.fc988267.webp";